export default "__VITE_ASSET__0cyv8F6f__"